<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <h1 class="ml-1 title font-weight-medium flex-shrink-0">
        สิทธิ์การลาบริษัท
      </h1>
      <div>
        <v-btn
          :disabled="!permissions.canCreate"
          color="primary"
          @click="handleAddLeaveType"
        >
          <v-icon small left>mdi-plus</v-icon>เพิ่มประเภทการลา
        </v-btn>
      </div>
    </div>
    <div class="my-2">
      <div class="d-flex justify-space-between align-end flex-wrap">
        <div>
          <v-text-field
            v-model="search"
            class="px-0"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 240px; padding: 1px 5px"
          ></v-text-field>
        </div>
        <div class="d-flex align-end flex-wrap">
          <div>
            <label class="caption">ประเภทพนักงาน</label>
            <v-select
              v-model="employmentTypeId"
              :items="[
                { text: 'พนักงานรายเดือน', value: 0 },
                { text: 'พนักงานรายวัน', value: 1 },
              ]"
              item-text="text"
              item-value="value"
              outlined
              dense
              hide-details
              style="width: 180px"
              @change="handleChangeEmploymentTypeId"
            ></v-select>
          </div>
          <div class="ml-2">
            <label class="caption">เริ่มวันที่</label>
            <v-card
              outlined
              style="
                padding: 9.5px 60px 9.5px 10px;
                font-size: 14px;
                cursor: not-allowed;
              "
              >{{ leavePeriodStartDate | formatDate }}</v-card
            >
          </div>
          <div class="ml-2">
            <label class="caption">ปีสิทธิ (ค.ศ.)</label>
            <div class="start-date-picker">
              <date-picker
                v-model="yearPeriod"
                type="year"
                :clearable="false"
              ></date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      :search="search"
      :headers="headers"
      :items="companyLeaveRights"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.leave_rights="{ item }">
        <span v-if="item.day_rights">{{ item.day_rights }} วัน</span>
        <span v-if="item.hour_rights"> {{ item.hour_rights }} ชั่วโมง</span>
      </template>
      <template v-slot:item.is_male="{ item }">
        <v-icon small color="success" v-if="item.is_male">mdi-check</v-icon>
        <v-icon small color="red darken-3" v-else>mdi-close</v-icon>
      </template>
      <template v-slot:item.is_female="{ item }">
        <v-icon small color="success" v-if="item.is_female">mdi-check</v-icon>
        <v-icon small color="red darken-3" v-else>mdi-close</v-icon>
      </template>
      <template v-slot:item.leave_type="{ item }">
        <v-icon small color="success" v-if="item.leave_type">
          mdi-check
        </v-icon>
        <v-icon small color="red darken-3" v-else>mdi-close</v-icon>
      </template>
      <template v-slot:item.is_include_days_off="{ item }">
        <span class="body-2" v-if="item.is_include_days_off">
          นับรวมวันหยุด
        </span>
        <span v-else class="grey--text text--darken-2">ไม่นับรวมวันหยุด</span>
      </template>
    </v-data-table>
    <CompanyLeaveRightForm
      :formShow="companyLeaveRightFormShow"
      :formAction="companyLeaveRightFormAction"
      :leaveRight="leaveRight"
      :leaveRightInit="leaveRightInit"
      :leaveType="leaveType"
      :leaveTypeInit="leaveTypeInit"
      @isCompanyLeaveRightDataChange="handleCompanyLeaveRightFormDataChange"
      @isLeaveTypeDataChange="handleLeaveTypeFormDataChange"
      @formActionCompleted="handleCompanyLeaveRightFormActionCompleted"
      @onReset="handleCompanyLeaveRightFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import CompanyLeaveRightForm from '@/views/company-leave-right/CompanyLeaveRightForm.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  components: {
    CompanyLeaveRightForm,
    ConfirmDialog,
    DatePicker,
  },
  data() {
    return {
      dialogForbidden: false,
      employmentTypeId: 0,
      leavePeriodStartDate: new Date(),
      yearPeriod: new Date(),
      sortBy: ['leave_type_code'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        {
          text: 'รหัสประเภทการลา',
          align: 'start',
          value: 'leave_type_code',
          class: 'text-no-wrap',
        },
        { text: 'ประเภทการลา', value: 'title_th', class: 'text-no-wrap' },
        {
          text: 'ประเภทการลา (อังกฤษ)',
          value: 'title_en',
          class: 'text-no-wrap',
        },
        {
          text: 'สิทธิการลา',
          align: 'end',
          class: 'text-no-wrap',
          sortable: false,
          value: 'leave_rights',
        },
        {
          text: 'ผู้ชาย',
          align: 'center',
          class: 'text-no-wrap',
          value: 'is_male',
          width: 90,
          sortable: false,
        },
        {
          text: 'ผู้หญิง',
          align: 'center',
          class: 'text-no-wrap',
          value: 'is_female',
          width: 90,
          sortable: false,
        },
        {
          text: 'คำนวณตามอายุงาน',
          align: 'center',
          class: 'text-no-wrap',
          sortable: false,
          value: 'leave_type',
          width: 140,
        },
        {
          text: 'การนับวันลา',
          align: 'start',
          class: 'text-no-wrap',
          value: 'is_include_days_off',
          width: 135,
        },
      ],
      companyLeaveRightFormShow: false,
      companyLeaveRightFormAction: '',
      leaveRight: {
        hour_rights: 0,
      },
      leaveRightInit: {
        hour_rights: 0,
      },
      isCompanyLeaveRightDataChange: false,
      cancelSource: null,
      timeout: null,
      companyLeaveRights: [],
      leaveType: {},
      leaveTypeInit: {},
      isLeaveTypeDataChange: false,
    }
  },
  filters: {
    formatDate: function (value) {
      return moment(value).format('DD/MM/YYYY')
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    permissions() {
      return {
        canCreate:
          this.uiCtrl?.isEnable('btn:::leave:leave_rights:company:create') ??
          true,
        canViewRow:
          this.uiCtrl?.isEnable('row:::leave:leave_rights:company:get') ?? true,
      }
    },
  },
  watch: {
    async yearPeriod() {
      await this.getConfigLeavePeriodStartDate()
      await this.loadData()
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'สิทธิ์การลาบริษัท',
        disabled: true,
      },
    ])

    await this.getConfigLeavePeriodStartDate()
    await this.loadData()
  },
  methods: {
    ...mapActions({
      fetchCompanyLeaveRights: 'companyLeaveRight/fetchCompanyLeaveRights',
      fetchConfigLeavePeriodStartDate: 'leave/fetchConfigLeavePeriodStartDate',
      fetchLeaveTypes: 'leaveType/fetchLeaveTypes',
    }),
    handleAddLeaveType() {
      this.companyLeaveRightFormShow = true
      this.companyLeaveRightFormAction = 'add'

      this.leaveRight = {
        hour_rights: 0,
      }
      this.leaveRightInit = {
        hour_rights: 0,
      }

      this.leaveType = {
        leave_type: null,
        gender_leave_type: 'male_and_female',
        year_period: this.yearPeriod
          ? this.yearPeriod instanceof Date
            ? this.yearPeriod.getFullYear()
            : parseInt(this.yearPeriod)
          : null,
      }
      this.leaveTypeInit = {
        leave_type: null,
        gender_leave_type: 'male_and_female',
        year_period: this.yearPeriod
          ? this.yearPeriod instanceof Date
            ? this.yearPeriod.getFullYear()
            : parseInt(this.yearPeriod)
          : null,
      }
    },
    handleLeaveTypeFormDataChange(value) {
      this.isLeaveTypeDataChange = value
    },
    async handleChangeEmploymentTypeId() {
      await this.getConfigLeavePeriodStartDate()
      await this.loadData()
    },
    async getConfigLeavePeriodStartDate() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'company-leave-rights-to-get-system-config-leave-entitlements',
          },
        }

        await this.fetchConfigLeavePeriodStartDate(payload)
        const configLeavePeriodStartDate =
          this.$store.state.leave.configLeavePeriodStartDate
        if (configLeavePeriodStartDate) {
          const employmentType =
            this.employmentTypeId === 0 ? 'monthly' : 'daily'
          const config = configLeavePeriodStartDate[employmentType]

          if (config && config.day && config.month) {
            const year =
              this.yearPeriod instanceof Date
                ? this.yearPeriod.getFullYear()
                : parseInt(this.yearPeriod)
            const adjustedYear = config.month >= 10 ? year - 1 : year
            const startDate = new Date(
              adjustedYear,
              config.month - 1,
              config.day
            )
            if (!isNaN(startDate.getTime())) {
              this.leavePeriodStartDate = startDate
            }
          }
        }
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    classRowSelected(row) {
      if (this.leaveRight.leave_type_uuid === row.leave_type_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (
        this.uiCtrl &&
        !this.uiCtrl.isEnable('row:::leave:leave_rights:company:get')
      ) {
        this.dialogForbidden = true
        return
      }

      if (this.leaveRight.leave_type_uuid === row.leave_type_uuid) {
        this.companyLeaveRightFormShow = false
        this.companyLeaveRightFormAction = ''
        this.leaveRight = {}
        this.leaveRightInit = {}
        this.leaveType = {}
        this.leaveTypeInit = {}
      } else {
        this.companyLeaveRightFormShow = true
        this.companyLeaveRightFormAction = 'edit'
        this.leaveRight = {
          ...row,
          hour_rights: row.hour_rights || 0,
        }
        this.leaveRightInit = {
          ...row,
          hour_rights: row.hour_rights || 0,
        }
        this.leaveType = {
          ...row,
          gender_leave_type:
            row.is_male && row.is_female
              ? 'male_and_female'
              : row.is_male
              ? 'male'
              : 'female',
          year_period: this.yearPeriod
            ? this.yearPeriod instanceof Date
              ? this.yearPeriod.getFullYear()
              : parseInt(this.yearPeriod)
            : null,
        }
        this.leaveTypeInit = {
          ...row,
          gender_leave_type:
            row.is_male && row.is_female
              ? 'male_and_female'
              : row.is_male
              ? 'male'
              : 'female',
          year_period: this.yearPeriod
            ? this.yearPeriod instanceof Date
              ? this.yearPeriod.getFullYear()
              : parseInt(this.yearPeriod)
            : null,
        }
      }
    },
    handleRowSelected(row) {
      if (this.isCompanyLeaveRightDataChange || this.isLeaveTypeDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleCompanyLeaveRightFormDataChange(value) {
      this.isCompanyLeaveRightDataChange = value
    },
    handleCompanyLeaveRightFormReset(formAction) {
      this.leaveRight = {}
      this.leaveRightInit = {}
      this.leaveType = {}
      this.leaveTypeInit = {}
      this.companyLeaveRightFormShow = false
      this.companyLeaveRightFormAction = ''
    },
    async handleCompanyLeaveRightFormActionCompleted(formAction) {
      this.leaveRight = {}
      this.leaveRightInit = {}
      this.leaveType = {}
      this.leaveTypeInit = {}
      this.companyLeaveRightFormShow = false
      this.companyLeaveRightFormAction = ''

      if (formAction !== 'close') {
        await this.getConfigLeavePeriodStartDate()
        await this.loadData()
      }
    },
    async loadData() {
      try {
        if (this.cancelSource) {
          this.cancelSource.abort()
        }

        const controller = new AbortController()
        this.cancelSource = controller

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'company-leave-rights-to-list-company-leave-rights',
            employment_type_id: this.employmentTypeId,
            leave_period_start_date: this.leavePeriodStartDate
              ? [
                  this.leavePeriodStartDate.getFullYear(),
                  String(this.leavePeriodStartDate.getMonth() + 1).padStart(
                    2,
                    '0'
                  ),
                  String(this.leavePeriodStartDate.getDate()).padStart(2, '0'),
                ].join('-')
              : null,
            year_period: this.yearPeriod
              ? this.yearPeriod instanceof Date
                ? this.yearPeriod.getFullYear()
                : parseInt(this.yearPeriod)
              : null,
          },
          signal: controller.signal,
        }

        this.loading = true

        await Promise.all([
          this.fetchLeaveTypes({
            company_uuid,
            params: {
              dpc: 'company-leave-rights-to-list-leave-type',
            },
          }),
          this.fetchCompanyLeaveRights(payload),
        ])

        const leaveTypes = this.$store.state.leaveType.leaveTypes
        const companyLeaveRights =
          this.$store.state.companyLeaveRight.companyLeaveRights

        this.companyLeaveRights = leaveTypes.map((type) => {
          const leaveRight = companyLeaveRights.find(
            (right) => right.leave_type_uuid === type.leave_type_uuid
          )
          return {
            ...leaveRight,
            ...type,
          }
        })
      } catch (error) {
        if (error.name === 'CanceledError') {
          // Request was cancelled, do nothing
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loading = false
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.companyLeaveRightFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isCompanyLeaveRightDataChange || this.isLeaveTypeDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    if (this.cancelSource) {
      this.cancelSource.abort()
    }

    clearTimeout(this.timeout)
  },
}
</script>

<style scoped>
::v-deep .start-date-picker input {
  font-weight: 600 !important;
  color: #333333 !important;
}
</style>
